<template>
  <div class="profile">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="color: #fff;">
        <use xlink:href="#icon-a-PaidPlacement"></use>
      </svg>
    </breadcrumbs>
    <a-tabs v-model:activeKey="filter.status" @change="getList">
      <a-tab-pane key="pending" :tab="`Pending(${counts.pendingCount || 0})`"></a-tab-pane>
      <a-tab-pane key="rejected" :tab="`Rejected(${counts.rejectedCount || 0})`"></a-tab-pane>
      <a-tab-pane key="approved" :tab="`Approved(${counts.approvedCount || 0})`"></a-tab-pane>
    </a-tabs>
    <a-spin :spinning="loading">
    <div class="table">
      <div class="table-item" v-for="value in list" :key="value.id">
        <div class="table-item-header" v-if="filter.status === 'pending'">
          <artmisads-select-button @click="approvePlacement(value.id)">Approve</artmisads-select-button>
          <artmisads-select-button @click="rejectPlacement(value.id)">Reject</artmisads-select-button>
        </div>
        <div class="content">
          <LogoImage :width="80" :height="80" :logoUrl="value.publisher.publicImage" :brandName="value.publisher.creatorName" />
          <div class="table-item-content-wrapper">
          <div class="table-item-content">
            <div class="table-item-content-item">
              <div class="name">Publisher</div>
              <div class="description">{{ value.publisher.creatorName }}</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">PlacementName</div>
              <div class="description">{{ value.name }}</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">PlacementDescription</div>
              <div class="description">{{ value.description }}</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">Specs</div>
              <div class="description">{{ value.specifications }}</div>
            </div>
          </div>
          <div class="table-item-content">
            <div class="table-item-content-item">
              <div class="name">Price</div>
              <div class="description">${{ value.price }}</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">Duration</div>
              <div class="description">{{ value.durationDays }} days</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">LinkType</div>
              <div class="description">{{ value.linkType }}</div>
            </div>
            <div class="table-item-content-item">
              <div class="name">Examples</div>
              <div class="description example-item">
                <div  v-for="example in value.exampleFiles" :key="example.id">
                  <div class="example-item-image" v-if="isImage(example.url)">
                    <a-image :src="example.url" alt="" :placeholder="true"
                    />
                  </div>
                  <div v-else>
                  {{ example.originalFileName }}
                </div>
                </div>
              </div>
            </div>
            

          </div>
          <div class="table-item-content" v-if="filter.status === 'rejected'">
            <div class="table-item-content-item">
              <div class="name">Reject Reason</div>
              <div class="description">{{ value.rejectionReason }}</div>
           </div>
          </div>
         
        </div>
        </div>

      </div>
      <div v-if="list.length === 0"
        style="display: flex;min-height: 300px;justify-content: center;align-items: center;">
        <a-empty />
      </div>
    </div>
    <div style="display: flex;justify-content: right;" v-if="list.length > 0">
      <a-pagination show-less-items show-size-changer :total="pager.total" :pageSize="pager.size" @change="onPageChange"
         v-model:current="pager.page" :show-total="(total) => `Total ${total} items`" />
    </div>
    </a-spin>
    <model ref="modelRef" @refresh="refresh" />
  </div>
</template>

<script setup lang="jsx">
import { ref, reactive, onMounted } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import { financeApi } from "~/server/operator/finance"
import LogoImage from '@/components/LogoImage.vue'
import model from './model.vue'
import { message } from 'ant-design-vue'

const breadcrumbsData = {
    title: "Placement Review",
    des: "Manage your placements campaigns information",
    color: '#80C026',
    links: [
        {
            name: "Home",
            path: "/operator/users",
        },
        {
            name: "Paid Placement",
            path: "/operator/paidPlacement/placement",
        },
        {
            name: "Placement Review",
            path: "/operator/paidPlacement/placement",
        },
    ],
}
const modelRef = ref(null)
const loading = ref(false)
const filter = reactive({
  status: 'pending',
})
const counts = ref('')
const list = ref([])
const pager = reactive({
  page: 1,
  size: 10,
  total: 0
})
const getList = async (v, type) => {
  loading.value = true

  if (v) { // 切换tab
    pager.page = 1
  }
  let params = {
    ...filter,
    ...pager,
  }
  const data = await financeApi.getFinancePlacementReview(params)
 
  list.value = data.data
  pager.total = data.total
  loading.value = false
}
const getCount = async () => {
  const data = await financeApi.getFinancePlacementCount()
  
  counts.value = data
}
const isImage = (url) => {
  if(!url) return 
  return url.includes('.jpg') || url.includes('.jpeg') || url.includes('.png')
}
const onPageChange = (page, size) => {
  pager.page = page
  pager.size = size
  getList()
}
const approvePlacement = (id) => {
 console.log('执行了')
  financeApi.placementApprove(id).then(res => {
  
   if(res){
    message.success('Approve Success!')
    refresh()
   }
  })
}
const rejectPlacement = (id) => {
  modelRef.value.open(id)
  // financeApi.placementReject(id).then(res => {
   
  //   if(res){
  //     message.success('Reject Success!')
  //     getList()
  //   }

  // })
}
const refresh = () => {
  getCount()
  getList()
}
onMounted(async () => {
  await getCount()
  await getList()
})
</script>

<style scoped lang="less">
.profile {
  padding: 24px;

  .table {
    .table-item {
      background-color: #fff;
      padding: 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      .table-item-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        padding-bottom: 16px;
        border-bottom: 1px solid var(--border-1);
      }

      .table-item-content {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 0;
        flex: 1;

        .table-item-content-item {
          .name {
            font-size: 14px;
            font-weight: 600;
            color: var(--text-1);
          }
          .example-item{
              display: flex;
              align-items: center;
              gap: 10px;
              flex-wrap: wrap;
            }
          .description {
            font-size: 14px;
            color: var(--text-2);
            font-weight: 400;
            margin-top: 4px;
           
            .example-item-image{
              width: 100px;
              height: 100px;

    background: var(--bg-gray-2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
             :deep(img){
                max-width: 100px;
                max-height: 100px;
                object-fit: contain;
              }
              // a-image{
              //   width: 100%;
              //   height: 100%;
              //   object-fit: cover;
              // }
            }
          }

          flex: 1;
        }
      }
    }

    .content {
      display: flex;
      flex: 1;
      margin-top: 16px;
      .table-item-content-wrapper{
        flex: 1;
        margin-left: 16px;
      }
      .table-item-content{
        flex: 1;
      }
    }
  }
}
.imgBox{
  width: 100px;
  height: 50px;
   border: 1px solid #E5E5E5;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F1F0F5;
   :deep(img) {
    max-width: 100px;
    max-height: 50px;
    object-fit: cover;
  }
}
</style>